<div class="calendar calendar-wrapper border-round-xl shadow-2 overflow-hidden mt-4">
  
  <!-- Loading Spinner Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
      <p class="loading-text mt-3">Loading calendar data...</p>
    </div>
  </div>

  <!-- Left Side Panel (Yellow-Green) -->
  <div class="left-panel" *ngIf="!isMentorView">
    
    <!-- State 1: No Date Selected or No Tasks -->
    <div *ngIf="!selectedCalendarDay || selectedCalendarDay.events.length === 0" class="w-full h-full p-0 m-0">
      <img src="assets/images/student_mentor_task_not selected.png" alt="Select a date" class="w-full h-full block" style="object-fit: cover;">
    </div>

    <!-- State 2: Date Selected with Tasks -->
    <div *ngIf="selectedCalendarDay && selectedCalendarDay.events.length > 0" class="w-full h-full relative p-5 flex flex-column justify-content-between" style="z-index: 1;">
      <!-- Background Image -->
      <img src="assets/images/student_mentor_task_selected.png" class="absolute top-0 left-0 w-full h-full" style="object-fit: cover; z-index: 0; pointer-events: none;">
      
      <!-- Content Overlay -->
      <div class="relative z-1 flex flex-column h-full w-full justify-content-between">
        <div class="flex flex-column">
          <div class="date-header mb-4">
            <h1 class="m-0" style="color: #111111; font-size: 48px; font-weight: 800; line-height: 1; font-family: 'Poppins', sans-serif;">
              {{ selectedCalendarDay.date | date: 'd' }}
            </h1>
            <h2 class="m-0 mt-1" style="color: #111111; font-size: 24px; font-weight: 700; font-family: 'Poppins', sans-serif;">
              {{ selectedCalendarDay.date | date: 'MMMM' }}
            </h2>
          </div>

          <h3 class="m-0 mb-4" style="color: #000086; font-size: 22px; font-weight: 800; font-family: 'Poppins', sans-serif;">
            Tasks assigned
          </h3>

          <div class="task-list flex flex-column gap-3 overflow-y-auto pr-2" style="max-height: 600px;">
            <div *ngFor="let task of selectedCalendarDay.events" 
                 class="task-item cursor-pointer flex align-items-center pl-3 py-2 bg-white-alpha-20 hover:bg-white-alpha-30 border-round-sm"
                 [style.border-left]="'6px solid ' + (task.backgroundColor || '#000086')"
                 (click)="onTaskClick(task)"
                 style="transition: background-color 0.2s;">
              <span style="color: #111111; font-size: 14px; font-weight: 600; font-family: 'Sora', sans-serif; line-height: 1.4;">
                {{ task.name.length > 50 ? (task.name | slice:0:50) + '...' : task.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side Panel (Calendar Grid) -->
  <div class="right-panel">
    
    <!-- Header: Filter Dropdown & Month Navigation -->
    <div class="calendar-header">
      <!-- Left Navigation Button -->
      <button class="nav-btn prev-btn" (click)="prevMonth()">
        <i class="pi pi-chevron-left"></i>
      </button>

      <!-- Month Navigation Controls -->
      <div class="flex flex-column align-items-center relative" style="cursor: pointer;">
        <!-- Hidden p-calendar to keep functionality but style it purely as the pills -->
        <p-calendar [(ngModel)]="selectedDate" view="month" dateFormat="MM yy" (onSelect)="onCalendarSelect($event)"
                    styleClass="absolute opacity-0 w-full h-full" [style]="{width: '100%', height: '100%', opacity: 0, zIndex: 10}"></p-calendar>
        <div class="month-pill px-5 py-2 border-round-3xl relative z-1 pointer-events-none" style="background-color: #000086;">
          <span class="text-white font-bold text-xl" style="font-family: 'Poppins', sans-serif;">
            {{ selectedDate | date: 'MMMM' }}
          </span>
        </div>
        <div class="year-pill px-3 py-1 border-round-3xl mt-1 relative z-1 pointer-events-none" style="background-color: #D9DA5F;">
          <span class="font-bold text-sm" style="color: #000086; font-family: 'Poppins', sans-serif;">
            {{ selectedDate | date: 'yyyy' }}
          </span>
        </div>
      </div>

      <!-- Right Navigation Button -->
      <button class="nav-btn next-btn" (click)="nextMonth()">
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>

    <!-- Calendar Grid -->
    <div class="calendar-container flex-grow-1 flex flex-column w-full border-none shadow-none mt-0">
      
      <!-- Days of Week Header -->
      <div class="calendar-days-row w-full mb-3 bg-white border-none">
        <div class="calendar-day-header text-center font-bold border-none" *ngFor="let day of daysOfWeek" style="color: #111111; font-family: 'Sora', sans-serif; font-size: 15px;">
          {{ day }}
        </div>
      </div>

      <!-- Grid Cells -->
      <div class="calendar-grid w-full">
        <div class="calendar-day flex flex-column bg-white" 
             *ngFor="let day of calendarDays; let dayIndex = index"
             [ngClass]="{
               'other-month': !day.isCurrentMonth,
               'selected-day': selectedCalendarDay?.date === day.date
             }"
             (click)="onDayClick(day)"
             style="min-height: 100px; padding: 10px; cursor: pointer; border: none; transition: background-color 0.2s; border-radius: 8px;">
             
          <!-- Date Label -->
          <div class="date-label text-center font-bold mb-2 w-full" 
               style="font-size: 18px; font-family: 'Poppins', sans-serif; color: #111111; height: 32px; display: flex; align-items: center; justify-content: center;">
            <span [ngClass]="{'today-label': day.isToday, 'other-month': !day.isCurrentMonth}">
              {{ day.date | date: 'd' }}
            </span>
          </div>

          <!-- Tasks as text links -->
          <div class="tasks-container flex flex-column gap-1 overflow-hidden" style="max-height: 80px; margin-top: 4px;">
            <div *ngFor="let task of day.events | slice:0:3" class="task-pill text-center w-full white-space-nowrap overflow-hidden text-overflow-ellipsis border-round-xl px-1"
                 [style.background-color]="task.colourCode || '#000086'"
                 [style.color]="task.color || '#ffffff'"
                 style="font-size: 10px; font-weight: 600; font-family: 'Sora', sans-serif; padding: 2px 0;">
              {{ task.typeName || 'Task' }}
            </div>
            <div *ngIf="day.events.length > 3" class="text-center w-full" style="font-size: 10px; font-weight: 700; color: #9ca3af; font-family: 'Sora', sans-serif;">
              +{{ day.events.length - 3 }} more
            </div>
          </div>

        </div>
      </div>
      
    </div>
  </div>
</div>

<!-- Task Details Dialog -->
<p-dialog header="Task Details" [(visible)]="isVisible" [modal]="true" [style]="{width: '40vw'}">
  <div *ngIf="selectedTask">
    <div class="flex flex-column align-items-start gap-4">
      <div class="flex flex-column gap-1">
        <b class="text-left font-normal text-sm" style="color: #515055;">Task Name</b>
        <p class="text-left font-normal text-base" style="color: #212022;">{{ selectedTask.question }}</p>
      </div>

      <div class="flex align-items-center justify-content-between gap-4">
        <div class="flex align-items-center gap-2">
          <b class="text-left font-normal text-sm" style="color: #515055;">Task Type:</b>
          <p class="text-left font-normal text-base m-0" style="color: #212022;"> {{ getTaskTypeName(selectedTask.type) }}</p>
        </div>
        <div class="flex align-items-center gap-2">
          <b class="text-left font-normal text-sm" style="color: #515055;">Status:</b>
          <div class="status-badge px-2 py-1 border-round"
            [ngClass]="'status-' + (selectedTask.status?.toLowerCase() || 'pending')">
            {{ selectedTask.status || 'Pending' }}
          </div>
        </div>
      </div>

      <!-- Attachment Buttons -->
      <div *ngIf="selectedTask.attachment || selectedTask.requestedAttachment" class="flex flex-wrap gap-4 mt-3">
        <button *ngIf="selectedTask.requestedAttachment" pButton
          label="Mentor Attachment"
          icon="pi pi-paperclip"
          class="p-button-outlined p-button-sm"
          styleClass="p-button-primary"
          (click)="openFile(selectedTask.requestedAttachment)"
          [disabled]="!selectedTask">
        </button>
        <button *ngIf="selectedTask.attachment" pButton
          label="Student Attachment"
          icon="pi pi-paperclip"
          class="p-button-outlined p-button-sm"
          styleClass="p-button-success"
          (click)="openFile(selectedTask.attachment)"
          [disabled]="!selectedTask">
        </button>
      </div>

      <div class="w-full flex gap-2">
        <div class="flex-1 flex flex-column gap-1 px-3 py-2 border-round-lg" style="background-color: #E6E5F3;">
          <b class="text-left font-normal text-sm flex gap-2" style="color: #515055;">
            <i class="pi pi-calendar"></i> Start Date
          </b>
          <p class="text-left font-normal text-sm" style="color: #212022;">
            {{ selectedTask.startDate | date: 'medium' }}
          </p>
        </div>
        <div class="flex-1 flex flex-column gap-1 px-3 py-2 border-round-lg" style="background-color: #FDEAB2;">
          <b class="text-left font-normal text-sm flex gap-2" style="color: #515055;">
            <i class="pi pi-calendar"></i> End Date
          </b>
          <p class="text-left font-normal text-sm" style="color: #212022;">
            {{ selectedTask.endDate | date: 'medium' }}
          </p>
        </div>
      </div>

      <div class="w-full" *ngIf="isTaskOverdue(selectedTask)">
        <div class="overdue-warning p-3 border-round" style="background-color: #ffebee; border: 1px solid #f44336;">
          <i class="pi pi-exclamation-triangle" style="color: #f44336;"></i>
          <span class="ml-2" style="color: #f44336;">This task is overdue</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
